import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { FEATURE_FLAGS_LIST_QUERY_KEY } from "./use-feature-flags-list";

/**
 * `POST /api/admin/feature-flags/refresh` returns 204 No Content.
 * After the server-side cache flushes we also drop the local TanStack
 * Query cache so the next list fetch reflects whatever the refreshed
 * pod returns.
 */
async function refreshFeatureFlagsCache(): Promise<void> {
  await httpClient<null>("/api/admin/feature-flags/refresh", { method: "POST" });
}

export function useRefreshFeatureFlagsCache() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: refreshFeatureFlagsCache,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FEATURE_FLAGS_LIST_QUERY_KEY });
    },
  });
}
